import anime, { set } from 'animejs';
import React, { useEffect, useRef, useState } from 'react';
import HomeButton from '../utils/HomeButton';

const audioIntro = new Audio(process.env.PUBLIC_URL + '/assets/sounds/diphonique_intro.mp3')

const audio1 = new Audio(process.env.PUBLIC_URL + '/assets/sounds/diphonique_1.mp3')
const audio2 = new Audio(process.env.PUBLIC_URL + '/assets/sounds/diphonique_2.mp3')
const audio3 = new Audio(process.env.PUBLIC_URL + '/assets/sounds/diphonique_3.mp3')
const audio4 = new Audio(process.env.PUBLIC_URL + '/assets/sounds/diphonique_4.mp3')

const note1Audio = new Audio(process.env.PUBLIC_URL + '/assets/sounds/diphonique_test_1.mp3')
const note2Audio = new Audio(process.env.PUBLIC_URL + '/assets/sounds/diphonique_test_2.mp3')
const note3Audio = new Audio(process.env.PUBLIC_URL + '/assets/sounds/diphonique_test_3.mp3')
const note4Audio = new Audio(process.env.PUBLIC_URL + '/assets/sounds/diphonique_test_4.mp3')

const Diphonique = (props) => {

    const [cursorIntroPos, setCursorIntroPos] = useState(0);
    const cursorIntroPosRef = useRef(cursorIntroPos);

    const [audioPlay, setAudioPlay] = useState(0);
    const [cursorPos, setCursorPos] = useState(0);
    const cursorPosRef = useRef(cursorPos);
    const [audioCurrent, setAudioCurrent] = useState(1)
    const audioCurrentRef = useRef(audioCurrent)

    const [page, setPage] = useState(1);
    const pageRef = useRef(page);

    const [showMenu1, setShowMenu1] = useState(false);
    const [showMenu2, setShowMenu2] = useState(false);

    const [showExplications1, setShowExplications1] = useState(false);
    const [showExplications2, setShowExplications2] = useState(false);
    const [showExplications3, setShowExplications3] = useState(false);

    const [showTest, setShowTest] = useState(false);

    const [showCorps1, setShowCorps1] = useState(false);
    const [showCorps2, setShowCorps2] = useState(false);
    const [showCorps3, setShowCorps3] = useState(false);
    const [showCorps4, setShowCorps4] = useState(false);

    const [note1Hovered, setNote1Hovered] = useState(false);
    const [note2Hovered, setNote2Hovered] = useState(false);
    const [note3Hovered, setNote3Hovered] = useState(false);
    const [note4Hovered, setNote4Hovered] = useState(false);
    const note1HoveredRef = useRef(note1Hovered)
    const note2HoveredRef = useRef(note2Hovered)
    const note3HoveredRef = useRef(note3Hovered)
    const note4HoveredRef = useRef(note4Hovered)


    const [note1Playing, setNote1Playing] = useState(false);
    const [note2Playing, setNote2Playing] = useState(false);
    const [note3Playing, setNote3Playing] = useState(false);
    const [note4Playing, setNote4Playing] = useState(false);
    const note1PlayingRef = useRef(note1Playing)
    const note2PlayingRef = useRef(note2Playing)
    const note3PlayingRef = useRef(note3Playing)
    const note4PlayingRef = useRef(note4Playing)

    const [spectres, setSpectres] = useState([])
    const spectresRef = useRef(spectres)



    const [showCorps5, setShowCorps5] = useState(false);
    const [imageSrc, setImageSrc] = useState('boucheanim1.png');
    const imageSrcRef = useRef(imageSrc);


    /* the cursor pos is determined depending on the music current time */
    /* the cursor pos is between 43 and 573 when the duration is between 0 and 24.4sec */
    /* the cursor pos is between 43 and 573 when the duration is between 24.4 and 46.3sec */
    /* (proportionnaly) */
    const getIntroCursorPos = () => {
        if (audioIntro.currentTime < 24.4) {
            return 43 + (audioIntro.currentTime * 530) / 24.4
        } else {
            return 43 + ((audioIntro.currentTime - 24.4) * 474) / (46.3 - 24.4)
        }
    }

    const playIntro = () => {
        setPage(1)
        pageRef.current = 1
        const offset = 5000
        setTimeout(() => {
            if (pageRef.current == 1) {
                audioIntro.play()
            }
        }, offset)
        let tl = anime.timeline()
        tl.add({
            targets: '#intro_img_2',
            opacity: 1,
            duration: 1000,
            easing: 'linear',
        }, 12.5 * 1000 + offset)
        tl.add({
            targets: '#intro_img_1',
            opacity: 0,
            duration: 1000,
            easing: 'linear',
        }, 12.5 * 1000 + offset)
            .add({
                targets: '#intro_img_4',
                opacity: 1,
                duration: 400,
                easing: 'linear',
            }, 24.4 * 1000 + offset)
            .add({
                targets: '#intro_img_2',
                opacity: 0,
                duration: 400,
                easing: 'linear',
            }, 24.4 * 1000 + offset)
            .add({
                targets: '#intro_img_3',
                opacity: 1,
                duration: 1000,
                easing: 'linear',
            }, 36 * 1000 + offset)
            .add({
                targets: '#intro_img_4',
                opacity: 0,
                duration: 1000,
                easing: 'linear',
            }, 36 * 1000 + offset)

        //textes
        tl.add({
            targets: '#intro_text_4',
            opacity: 1,
            duration: 1000,
            easing: 'linear',
        }, 1000)
            .add({
                targets: '#intro_text_4',
                opacity: 0,
                duration: 1000,
                easing: 'linear',
            }, 3000)
            .add({
                targets: '#intro_text_1',
                opacity: 1,
                duration: 1000,
                easing: 'linear',
            }, 4000)
            .add({
                targets: '#intro_text_1',
                opacity: 0,
                duration: 1000,
                easing: 'linear',
            }, 6000)
            .add({
                targets: '#intro_hide',
                zIndex: 1,
                duration: 1000,
                easing: 'linear',
            }, 7000)
            .add({
                targets: '#intro_title',
                opacity: 0,
                duration: 1000,
                easing: 'linear',
            }, 7000)
            .add({
                targets: '#intro_text_2',
                opacity: 1,
                duration: 1000,
                easing: 'linear',
            }, 9000)
            .add({
                targets: '#intro_text_2',
                opacity: 0,
                duration: 1000,
                easing: 'linear',
            }, 12000)
            .add({
                targets: '#intro_text_3',
                opacity: 1,
                duration: 1000,
                easing: 'linear',
            }, 13000)
            .add({
                targets: '#intro_text_3',
                opacity: 0,
                duration: 1000,
                easing: 'linear',
            }, 16000)


        setInterval(() => {
            if (pageRef.current == 1) {
                goToPage2();
            }
        }, 46.8 * 1000 + offset);
    }

    const skipIntro = () => {
        audioIntro.pause();
        goToPage2();
    }

    const goToPage2 = () => {
        audioIntro.pause()
        audioIntro.currentTime = 0
        pageRef.current = 2
        setPage(pageRef.current)
        setTimeout(() => {
            let tl = anime.timeline()
            tl.add({
                targets: '.window',
                opacity: 1,
                duration: 1000,
                easing: 'linear',
            }, 0)
            console.log('page 2')
        }, 1000)
    }

    const goToPage3 = () => {
        pageRef.current = 3
        setPage(pageRef.current)
        //reset cursor pos
        cursorPosRef.current = 66
        setCursorPos(cursorIntroPosRef.current)
        //set current audio to 1 and reset
        setAudioCurrent(1)
        audio1.pause()
        audio1.currentTime = 0
    }

    //The cursor goes between 66 and 592 for audio1 and 3, 536 for audio1 and 3, depending on the music current time
    //The music length is that of the current selected audio
    const getCursorPos = () => {
        if (audioCurrentRef.current === 1) {
            return 66 + (audio1.currentTime * 526) / audio1.duration
        } else if (audioCurrentRef.current === 2) {
            return 66 + (audio2.currentTime * 470) / audio2.duration
        } else if (audioCurrentRef.current === 3) {
            return 66 + (audio3.currentTime * 526) / audio3.duration
        } else if (audioCurrentRef.current === 4) {
            return 66 + (audio4.currentTime * 470) / audio4.duration
        }
    }

    const playAudio = () => {
        if(audioPlay==0){
            if (audioCurrentRef.current === 1) {
                audio1.play()
            } else if (audioCurrentRef.current === 2) {
                audio2.play()
            } else if (audioCurrentRef.current === 3) {
                audio3.play()
            } else if (audioCurrentRef.current === 4) {
                audio4.play()
            }
            setAudioPlay(1);//PB50
    }
    else{
        setAudioPlay(0);
        pauseAudio();
    }
    }

    const pauseAudio = () => {
        if (audioCurrentRef.current === 1) {
            audio1.pause()
        } else if (audioCurrentRef.current === 2) {
            audio2.pause()
        } else if (audioCurrentRef.current === 3) {
            audio3.pause()
        } else if (audioCurrentRef.current === 4) {
            audio4.pause()
        }
    }

    const stopAudio = () => {
        if (audioCurrentRef.current === 1) {
            audio1.pause()
            audio1.currentTime = 0
        } else if (audioCurrentRef.current === 2) {
            audio2.pause()
            audio2.currentTime = 0
        } else if (audioCurrentRef.current === 3) {
            audio3.pause()
            audio3.currentTime = 0
        } else if (audioCurrentRef.current === 4) {
            audio4.pause()
            audio4.currentTime = 0
        }
    }

    const getAudioTime = () => {
        if (audioCurrentRef.current === 1) {
            return audio1.currentTime;
        } else if (audioCurrentRef.current === 2) {
            return audio2.currentTime;
        } else if (audioCurrentRef.current === 3) {
            return audio3.currentTime;
        } else if (audioCurrentRef.current === 4) {
            return audio4.currentTime;
        }
    }

    const setAudioTime = (t) => {
        if (audioCurrentRef.current === 1) {
            audio1.currentTime = t;
        } else if (audioCurrentRef.current === 2) {
            audio2.currentTime = t;
        } else if (audioCurrentRef.current === 3) {
            audio3.currentTime = t;
        } else if (audioCurrentRef.current === 4) {
            audio4.currentTime = t;
        }
    }

    const addSpectre = (note) => {
        const newSpectres = [...spectresRef.current]
        //first add the image to spectre
        newSpectres.push(
            <img
                key={Date.now()}
                className='spectre_img'
                style={{
                    position: 'absolute',
                    top: '0px',
                    left: '-75px',
                }}
                src={process.env.PUBLIC_URL + `/assets/images/diphonique/s${note}.jpg`}
            />
        )

        //On ne garde que les 5 premiers elements de la liste
        spectresRef.current = newSpectres.slice(-5)

        setSpectres(spectresRef.current)
        //Animate to the left
        let duration = 0
        if (note == 1) {
            duration = note1Audio.duration * 1000
        } else if (note == 2) {
            duration = note2Audio.duration * 1000
        } else if (note == 3) {
            duration = note3Audio.duration * 1000
        } else if (note == 4) {
            duration = note4Audio.duration * 1000
        }

        //10 ms de delay le temps d'ajouter l'img au DOM
        setTimeout(() => {
            anime({
                targets: '.spectre_img',
                left: '+=75',
                duration: duration,
                easing: 'linear',
            })
        }, 10)

    }

    const playNote = (note) => {
        const isPlaying = note1PlayingRef.current | note2PlayingRef.current | note3PlayingRef.current | note4PlayingRef.current;
        if (!isPlaying) {
           //stopAudio()
            if (note == 1) {
                addSpectre(1)
                note1PlayingRef.current = true
                setNote1Playing(note1PlayingRef.current)
                note1Audio.currentTime = 0
                note1Audio.play()
                setTimeout(() => {
                    note1PlayingRef.current = false
                    setNote1Playing(note1PlayingRef.current)
                }, note1Audio.duration * 1000)
            } else if (note == 2) {
                addSpectre(2)
                note2PlayingRef.current = true
                setNote2Playing(note2PlayingRef.current)
                note2Audio.currentTime = 0
                note2Audio.play()
                setTimeout(() => {
                    note2PlayingRef.current = false
                    setNote2Playing(note2PlayingRef.current)
                }, note2Audio.duration * 1000)
            } else if (note == 3) {
                addSpectre(3)
                note3PlayingRef.current = true
                setNote3Playing(note3PlayingRef.current)
                note3Audio.currentTime = 0
                note3Audio.play()
                setTimeout(() => {
                    note3PlayingRef.current = false
                    setNote3Playing(note3PlayingRef.current)
                }, note3Audio.duration * 1000)
            } if (note == 4) {
                addSpectre(4)
                note4PlayingRef.current = true
                setNote4Playing(note4PlayingRef.current)
                note4Audio.currentTime = 0
                note4Audio.play()
                setTimeout(() => {
                    note4PlayingRef.current = false
                    setNote4Playing(note4PlayingRef.current)
                }, note4Audio.duration * 1000)
            }
        }
      
    }

    function clearAll() {
        // Get a reference to the last interval + 1
        const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);
        
        // Clear any timeout/interval up to that id
        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }
       
        props.audio.forEach(audio => audio.pause());
    }

    useEffect(() => {
        //Clear audios :
        clearAll() 

        props.audio.push(audio1)
        props.audio.push(audio2)
        props.audio.push(audio3)
        props.audio.push(audio4)
        props.audio.push(audioIntro)
        props.audio.push(note1Audio)
        props.audio.push(note2Audio)
        props.audio.push(note3Audio)
        props.audio.push(note4Audio)
        

        setInterval(() => {
            if (note1HoveredRef.current) {
                playNote(1)
                console.log('note 1');
            } else if (note2HoveredRef.current) {
                playNote(2)
                console.log('note 2');
            } else if (note3HoveredRef.current) {
                playNote(3)
                console.log('note 3');
            } else if (note4HoveredRef.current) {
                playNote(4)
                console.log('note 4');  
            }
        }, 100)

        setInterval(() => {
            if (pageRef.current === 3) {
                //oscillating image (imageSourceRef goes from 1 to 2 every 1s)
                if (imageSrcRef.current === 'boucheanim1.png') {
                    imageSrcRef.current = 'boucheanim2.png'
                } else {
                    imageSrcRef.current = 'boucheanim1.png'
                }
                setImageSrc(imageSrcRef.current)
            }
        }, 1000);

        setInterval(() => {
            if (pageRef.current === 1) {
                cursorIntroPosRef.current = getIntroCursorPos()
                setCursorIntroPos(cursorIntroPosRef.current)
            }
            if (pageRef.current === 3) {
                cursorPosRef.current = getCursorPos()
                setCursorPos(cursorPosRef.current)
            }
        }, 60);

        playIntro()
    }, []);

    return (
        <div
            style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '660px',
                height: '500px',
                zIndex: '1',
            }}
            className='background'
        >
            <img
                style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '660px',
                    height: '500px',
                    zIndex: '1',
                }}
                src={process.env.PUBLIC_URL + '/assets/images/diphonique/background.png'} alt='fond_rouge' />
            
            {/* intro */}

            {pageRef.current === 1 &&
                <>
                    <img
                        id='intro_img_1'
                        style={{
                            position: 'absolute',
                            top: '150px',
                            left: '50px',
                            zIndex: '2',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/images/diphonique/spectre_o1.png'} alt='intro' />
                    
                    <img
                        id='intro_img_2'
                        style={{
                            position: 'absolute',
                            top: '60px',
                            left: '50px',
                            zIndex: '2',
                            opacity: '0',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/images/diphonique/spectre1.jpg'} alt='intro' />
                    <img
                        id='intro_img_3'
                        style={{
                            position: 'absolute',
                            top: '150px',
                            left: '50px',
                            zIndex: '2',
                            opacity: '0',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/images/diphonique/spectre_o2.png'} alt='intro' />
                    <HomeButton />
                    <img
                        id='intro_img_4'
                        style={{
                            position: 'absolute',
                            top: '60px',
                            left: '50px',
                            zIndex: '2',
                            opacity: '0',
                            opacity: '0',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/images/diphonique/spectre2.jpg'} alt='intro' />
                    <div
                        id='intro_hide'
                        style={{
                            position: 'absolute',
                            top: '55px',
                            left: '30px',
                            width: '570px',
                            height: '350px',
                            zIndex: '2',
                            opacity: '0.2',
                            backgroundColor: 'blue',
                        }}
                    />
                    <p
                        id="intro_title"
                        style={{
                            position: 'absolute',
                            top: '100px',
                            left: '70px',
                            color: 'white',
                            zIndex: '3',
                            fontSize: '24px',
                            opacity: 1,
                        }}
                    >
                        Le chant diphonique
                    </p>
                    <p
                        id="intro_text_1"
                        style={{
                            position: 'absolute',
                            top: '215px',
                            left: '70px',
                            color: 'black',
                            width: '470px',
                            zIndex: '3',
                            fontSize: '16px',
                            textAlign: 'center',
                            opacity: 0,
                        }}
                    >
                        Comment les styles Mongols ou Tuva sont-ils produits sur le plan physiologiques ?
                    </p>
                    <p
                        id="intro_text_2"
                        style={{
                            position: 'absolute',
                            top: '215px',
                            left: '70px',
                            color: 'black',
                            width: '470px',
                            zIndex: '3',
                            fontSize: '14px',
                            textAlign: 'center',
                            opacity: 0,
                        }}
                    >
                        <i>Tuva - Voices from the center of tuva</i><br />
                        Smithsonian/Folkways, SF 40017
                    </p>
                    <p
                        id="intro_text_3"
                        style={{
                            position: 'absolute',
                            top: '215px',
                            left: '70px',
                            color: 'black',
                            width: '470px',
                            zIndex: '3',
                            fontSize: '14px',
                            textAlign: 'center',
                            opacity: 0,
                        }}
                    >
                        Enregistrement : E. Alekseev, Zoya Kirgiz, Ted Livin
                    </p>
                    <p
                        id="intro_text_4"
                        style={{
                            position: 'absolute',
                            top: '215px',
                            left: '70px',
                            color: 'black',
                            width: '470px',
                            zIndex: '3',
                            fontSize: '14px',
                            textAlign: 'center',
                            opacity: 0,
                        }}
                    >
                        En collaboration avec Tran Quanq Hai, d'après un film de Hugo Zemp
                    </p>
                    {/* cursor */}
                    <img
                        style={{
                            position: 'absolute',
                            top: '45px',
                            left: `${cursorIntroPosRef.current}px`,
                            zIndex: '3',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/images/diphonique/cursor.png'} alt='cursor'
                    />
                    {/* skip button */}
                    <p
                        style={{
                            position: 'absolute',
                            top: '435px',
                            left: '470px',
                            zIndex: 3,
                            color: 'white',
                            fontSize: '14px',
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            padding: '10px',
                            cursor: 'pointer'
                        }}
                        onClick={skipIntro}
                    >
                        &gt; &nbsp;
                        <span
                            style={{
                                textDecoration: 'underline'
                            }}
                        >
                            Passer l'intro
                        </span>
                    </p>
                </>
            }


            {/* page 2 */}
            {pageRef.current === 2 &&
                <>
                    <div
                        className='window'
                        style={{
                            position: 'absolute',
                            top: '50px',
                            left: '50px',
                            zIndex: 2,
                            width: '580px',
                            height: '380px',
                            //purple transparent
                            backgroundColor: 'rgba(150, 56, 232,0.2)',
                            opacity: '0',
                        }}
                    />
                    <HomeButton />
                    <div
                        className='window'
                        style={{
                            position: 'absolute',
                            top: '100px',
                            left: '100px',
                            zIndex: 3,
                            width: '400px',
                            height: '200px',
                            overflow: 'scroll',
                            color: 'white',
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            padding: '40px',
                            opacity: '0',
                        }}
                    >
                        Les Mongol et les Tuva distinguent différents styles de chants diphoniques désignés par des termes vernaculaires.<br />
                        Les travaux de Tran Quang Hai et Hugo Zemp montrent qu'il existe essentiellement deux techniques de chant diphonique, différenciées par la position de la langue dans la bouche, dite à "une cavité" ou "deux cavités".<br />
                        Leur hypothèse concernant les techniques utilisées pour chaque style est que tous les chants dont la mélodie d'harmoniques ne dépasse pas 1000 Hz sont réalisés à une cavité, et que tous ceux dont la mélodie d'harmoniques se situe entre 1000 et 2000 Hz sont réalisés à deux cavités.<br />
                        Ainsi :<br />
                        • Le style kargiraa des Tuwa (ou karkira des Mongol) se réalise à une cavité.<br />
                        • Le style sygyt des Tuwa se réalise à deux cavités.<br />
                        La pièce Tuva proposée dans cette animation alterne ces deux styles.<br />
                    </div>
                    <p
                        className='window'
                        style={{
                            position: 'absolute',
                            top: '374px',
                            left: '390px',
                            zIndex: 3,
                            color: 'white',
                            cursor: 'pointer',
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            padding: '10px',
                            fontSize: '14px',
                            opacity: '0',
                        }}
                        onClick={goToPage3}
                    >
                        &gt; &nbsp;
                        <span
                            style={{
                                textDecoration: 'underline'
                            }}
                        >
                            Fermer la fenêtre
                        </span>
                    </p>
                </>
            }

            {/* page 3 */}
            {pageRef.current === 3 &&
                <>
                    <img
                        style={{
                            position: 'absolute',
                            top: '50px',
                            left: '70px',
                            zIndex: 2,
                        }}
                        src={process.env.PUBLIC_URL + `/assets/images/diphonique/spectre${audioCurrentRef.current}.jpg`} alt='intro' />
                    <img
                        style={{
                            position: 'absolute',
                            top: '340px',
                            left: '540px',
                            width: '100px',
                            zIndex: 4,
                            cursor: 'pointer',
                            display: showExplications1 || showExplications2 || showExplications3 || showTest ? 'none' : 'block',
                        }}
                        src={process.env.PUBLIC_URL + `/assets/images/diphonique/bouche.png`} alt='intro'
                        onClick={() => {
                            setShowExplications1(true);
                            stopAudio()
                        }}
                    />
                    
                    <div
                        style={{
                            position: 'absolute',
                            top: '39px',
                            left: '60px',
                            zIndex: 1,
                            width: '548px',
                            height: '364px',
                            backgroundColor: 'rgba(245, 66, 117,0.5)',
                        }}
                    />
                    {/* cursor */}
                    <img
                        style={{
                            position: 'absolute',
                            top: '33px',
                            left: `${cursorPosRef.current}px`,
                            zIndex: '3',
                            userSelect: 'none',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/images/diphonique/cursor.png'} alt='cursor'
                    />

                    <p
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '470px',
                            zIndex: 3,
                            color: 'white',
                            fontSize: '20px',
                            fontStyle: 'italic',
                        }}
                    >
                        Le chant diphonique
                    </p>
                    <HomeButton />

                    {/*explications 1*/}
                    <div
                        className='explications1'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            zIndex: 5,
                            display: showExplications1 ? 'block' : 'none',
                        }}
                    >
                        <div
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                zIndex: 3,
                                width: '660px',
                                height: '500px',
                                backgroundColor: 'rgba(0,0,0,0.2)',
                            }}
                        />
                        <div
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '40px',
                                left: '40px',
                                zIndex: 3,
                                width: '260px',
                                height: '300px',
                                overflow: 'scroll',
                                color: 'white',
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                padding: '40px',
                            }}
                        >
                            <h2>Principe de la voix diphonique</h2>
                            La larynx est une source sonore qui délivre un spectre harmonique.<br />
                            Ce spectre résonne dans le conduit pharyngo-buccal constitué de cinq cavités : le <span style={{
                                color: 'orange',
                                textDecoration: 'underline',
                            }}
                                onMouseEnter={() => setShowCorps1(true)}
                                onMouseLeave={() => setShowCorps1(false)}
                            >pharynx</span>, la bouche qui peut être divisée par la langue en <span style={{
                                color: 'orange',
                                textDecoration: 'underline',
                            }}
                                onMouseEnter={() => setShowCorps2(true)}
                                onMouseLeave={() => setShowCorps2(false)}
                            >deux cavités</span>, <span style={{
                                color: 'orange',
                                textDecoration: 'underline',
                            }}
                                onMouseEnter={() => setShowCorps3(true)}
                                onMouseLeave={() => setShowCorps3(false)}
                            >espace entre les dents et les lèvres</span>, et la <span style={{
                                color: 'orange',
                                textDecoration: 'underline',
                            }}
                                onMouseEnter={() => setShowCorps4(true)}
                                onMouseLeave={() => setShowCorps4(false)}
                            >cavité nasale</span>.<br />
                            La fréquence propre de ces cavités (principalement celle de la bouche) peut être modifiée par contrôle de la forme des cavités.<br />
                            L'amplitude de la composante correspondante du spectre émis par le larynx se trouve ainsi augmentée par résonance.<br />
                            Le chant diphonique consiste à partir d'une note fondamentale grave, à émettre une mélodie d'harmoniques produites selon ce principe.<br />
                        </div>
                        <p
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '395px',
                                left: '390px',
                                width: '125px',
                                fontSize: '14px',
                                zIndex: 3,
                                color: 'white',
                                cursor: 'pointer',
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                padding: '10px',
                            }}
                            onClick={() => { setShowExplications1(false) }}
                        >
                            &gt; &nbsp;
                            <span
                                style={{
                                    textDecoration: 'underline'
                                }}
                            >
                                Fermer la fenêtre
                            </span>
                        </p>
                        <img
                            style={{
                                position: 'absolute',
                                top: '110px',
                                left: '410px',
                                width: '200px',
                                zIndex: 4,
                                cursor: 'pointer',
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/bouche2.jpg'} alt='intro'
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '221px',
                                left: '462px',
                                zIndex: 4,
                                display: showCorps1 ? 'block' : 'none',
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/pharynx.png'} alt='intro'
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '196px',
                                left: '492px',
                                zIndex: 4,
                                display: showCorps2 ? 'block' : 'none',
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/cavites.png'} alt='intro'
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '207px',
                                left: '552px',
                                zIndex: 4,
                                display: showCorps3 ? 'block' : 'none',
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/dents.png'} alt='intro'
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '181px',
                                left: '532px',
                                zIndex: 4,
                                display: showCorps4 ? 'block' : 'none',
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/cavitenasale.png'} alt='intro'
                        />
                    </div>

                    {/*explications 2*/}
                    <div
                        className='explications1'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            zIndex: 5,
                            display: showExplications2 ? 'block' : 'none',
                        }}
                    >
                        <div
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                zIndex: 3,
                                width: '660px',
                                height: '500px',
                                backgroundColor: 'rgba(0,0,0,0.2)',
                            }}
                        />
                        <div
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '40px',
                                left: '40px',
                                zIndex: 3,
                                width: '260px',
                                height: '300px',
                                overflow: 'scroll',
                                color: 'white',
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                padding: '40px',
                            }}
                        >
                            <h2>Technique à deux cavités</h2>
                            Dans cette technique, la pointe de la langue touche le palais, divisant la bouche en deux cavités. Les fréquences peuvent être sélectionnées de deux manières :<br />
                            a) – <span style={{
                                color: 'orange',
                                textDecoration: 'underline',
                            }}
                                onMouseEnter={() => setShowCorps5(true)}
                                onMouseLeave={() => setShowCorps5(false)}
                            > en deplaçant la langue de l'avant vers l'arrière </span> et en l'ajustant sur des positions qui correspondent à des fréquences harmoniques du spectree émis par le larynx (harmoniques les plus aigus obtenus avec la langue à l'avant de la bouche).<br />
                            b) – en maintenant la pointe de la langue en position fixe contre le palais et en déformant les lèvres pour prononcer des voyelles.<br />
                            Le "ou" permet d'obtenir l'harmonique la plus grave, le "i" permet d'obtenir l'harmonique la plus aigüe.<br />
                        </div>
                        <p
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '395px',
                                left: '390px',
                                width: '125px',
                                fontSize: '14px',
                                zIndex: 3,
                                color: 'white',
                                cursor: 'pointer',
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                padding: '10px',
                            }}
                            onClick={() => { setShowExplications2(false) }}
                        >
                            &gt; &nbsp;
                            <span
                                style={{
                                    textDecoration: 'underline'
                                }}
                            >
                                Fermer la fenêtre
                            </span>
                        </p>
                        <img
                            style={{
                                position: 'absolute',
                                top: '110px',
                                left: '410px',
                                width: '200px',
                                zIndex: 4,
                                cursor: 'pointer',
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/bouche2.jpg'} alt='intro'
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '110px',
                                left: '410px',
                                width: '200px',
                                zIndex: 4,
                                cursor: 'pointer',
                                display: showCorps5 ? 'block' : 'none',
                            }}
                            src={process.env.PUBLIC_URL + `/assets/images/diphonique/${imageSrcRef.current}`} alt='intro'
                        />
                    </div>

                    {/*explications 3*/}
                    <div
                        className='explications3'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            zIndex: 5,
                            display: showExplications3 ? 'block' : 'none',
                        }}
                    >
                        <div
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                zIndex: 3,
                                width: '660px',
                                height: '500px',
                                backgroundColor: 'rgba(0,0,0,0.2)',
                            }}
                        />
                        <div
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '40px',
                                left: '40px',
                                zIndex: 3,
                                width: '260px',
                                height: '300px',
                                overflow: 'scroll',
                                color: 'white',
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                padding: '40px',
                            }}
                        >
                            <h2>Technique à une cavité</h2>
                            Dans cette technique, la langue est au repos.<br />
                            Les fréquences sont sélectionnées par la forme de la bouche, qui constitue une seule cavité.<br />
                            Le contrôle des déformations de cette cavité est réalisé en prononçant différentes voyelles.<br />
                        </div>
                        <p
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '415px',
                                left: '390px',
                                width: '125px',
                                fontSize: '14px',
                                zIndex: 3,
                                color: 'white',
                                cursor: 'pointer',
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                padding: '10px',
                            }}
                            onClick={() => { setShowExplications3(false) }}
                        >
                            &gt; &nbsp;
                            <span
                                style={{
                                    textDecoration: 'underline'
                                }}
                            >
                                Fermer la fenêtre
                            </span>
                        </p>
                        <img
                            style={{
                                position: 'absolute',
                                top: '110px',
                                left: '410px',
                                width: '200px',
                                zIndex: 4,
                                cursor: 'pointer',
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/bouche.png'} alt='intro'
                        />
                    </div>

                    {/*test */}
                    <div
                        style={{
                            position: 'absolute',
                            top: '20px',
                            left: '20px',
                            width: '610px',
                            height: '415px',
                            zIndex: 3,
                            backgroundColor: 'rgba(0,0,0,0.35)',
                            display: showTest ? 'block' : 'none',
                        }}
                    />
                    <div
                        className='explications1'
                        style={{
                            position: 'absolute',
                            top: '0px',
                            left: '0px',
                            zIndex: 5,
                            display: showTest ? 'block' : 'none',
                        }}
                    >
                        <div
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                zIndex: 3,
                                width: '660px',
                                height: '500px',
                                backgroundColor: 'rgba(0,0,0,0.2)',
                            }}
                        />
                        <div
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '40px',
                                left: '40px',
                                zIndex: 3,
                                width: '228px',
                                height: '350px',
                                color: 'white',
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                padding: '0px',
                            }}
                        >
                            {/* visuel */}
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '10px',
                                    left: '0px',
                                    width: '225px',
                                    height: '272px',
                                    border: '2px solid black',
                                    zIndex: 3,
                                    overflow: 'hidden'
                                }}
                            >
                                {spectres}
                            </div>
                        </div>
                        <p
                            className='window'
                            style={{
                                position: 'absolute',
                                top: '395px',
                                left: '390px',
                                width: '125px',
                                fontSize: '14px',
                                zIndex: 3,
                                color: 'white',
                                cursor: 'pointer',
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                padding: '10px',
                            }}
                            onClick={() => { setShowTest(false); }}
                        >
                            &gt; &nbsp;
                            <span
                                style={{
                                    textDecoration: 'underline'
                                }}
                            >
                                Fermer la fenêtre
                            </span>
                        </p>
                        <img
                            style={{
                                position: 'absolute',
                                top: '90px',
                                left: '340px',
                                zIndex: 4,
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/grille.png'} alt='intro'
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '70px',
                                left: '340px',
                                zIndex: 4,
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/note.svg'} alt='intro'
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '115px',
                                left: '390px',
                                zIndex: 4,
                                cursor: 'pointer',
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/n1.png'} alt='intro'
                            onMouseEnter={() => { note1HoveredRef.current = true; setNote1Hovered(note1HoveredRef.current) }}
                            onMouseLeave={() => { note1HoveredRef.current = false; setNote1Hovered(note1HoveredRef.current) }}
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '110px',
                                left: '420px',
                                zIndex: 4,
                                cursor: 'pointer'
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/n2.png'} alt='intro'
                            onMouseEnter={() => { note2HoveredRef.current = true; setNote2Hovered(note2HoveredRef.current) }}
                            onMouseLeave={() => { note2HoveredRef.current = false; setNote2Hovered(note2HoveredRef.current) }}
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '104px',
                                left: '450px',
                                zIndex: 4,
                                cursor: 'pointer'
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/n2.png'} alt='intro'
                            onMouseEnter={() => { note3HoveredRef.current = true; setNote3Hovered(note3HoveredRef.current) }}
                            onMouseLeave={() => { note3HoveredRef.current = false; setNote3Hovered(note3HoveredRef.current) }}
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '92px',
                                left: '485px',
                                zIndex: 4,
                                cursor: 'pointer',
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/n1.png'} alt='intro'
                            onMouseOver={() => { note4HoveredRef.current = true; setNote4Hovered(note4HoveredRef.current) }}
                            onMouseLeave={() => { note4HoveredRef.current = false; setNote4Hovered(note4HoveredRef.current) }}
                            
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '170px',
                                left: '340px',
                                width: '200px',
                                zIndex: 4,
                                cursor: 'pointer',
                            }}
                            src={process.env.PUBLIC_URL + `/assets/images/diphonique/pos${(() => {
                                if (note1PlayingRef.current) {
                                    return '1'
                                } else if (note2PlayingRef.current) {
                                    return '2'
                                } else if (note3PlayingRef.current) {
                                    return '3'
                                } else if (note4PlayingRef.current) {
                                    return '4'
                                } else {
                                    return '1'
                                }
                            })()}.jpg`} alt='intro'
                        />
                        <div
                            style={{
                                position: 'absolute',
                                top: '170px',
                                left: '340px',
                                width: '200px',
                                height: '225px',
                                zIndex: 4,
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                display: note1PlayingRef.current | note2PlayingRef.current | note3PlayingRef.current | note4PlayingRef.current ? 'none' : 'block',
                            }}
                        />
                    </div>

                    {/* controls */}
                    <div
                        className='controls'
                        style={{
                            position: 'absolute',
                            top: '430px',
                            left: '60px',
                            zIndex: 3,
                        }}
                    >
                        <img
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                cursor: 'pointer',
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/play.png'} alt='play'
                            onClick={playAudio}
                        />
                        <img
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '30px',
                                cursor: 'pointer',
                            }}
                            src={process.env.PUBLIC_URL + '/assets/images/diphonique/stop.png'} alt='play'
                            onClick={stopAudio}
                        />
                        {audioCurrentRef.current === 1 &&
                            <img
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    left: '60px',
                                    cursor: 'pointer',
                                }}
                                src={process.env.PUBLIC_URL + '/assets/images/diphonique/right.png'} alt='play'
                                onClick={() => {
                                    audioCurrentRef.current = 2;
                                    setAudioCurrent(audioCurrentRef.current)
                                }}
                            />}
                        {audioCurrentRef.current === 2 &&
                            <img
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    left: '60px',
                                    cursor: 'pointer',
                                }}
                                src={process.env.PUBLIC_URL + '/assets/images/diphonique/left.png'} alt='play'
                                onClick={() => {
                                    audioCurrentRef.current = 1;
                                    setAudioCurrent(audioCurrentRef.current)
                                }}
                            />}
                        {/* drop-up menu n1 */}
                        <div
                            onMouseEnter={() => { setShowMenu1(true); }}
                            onMouseLeave={() => { setShowMenu1(false); }}
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '-10px',
                                    left: '115px',
                                    width: '145px',
                                    height: '39px',
                                    border: '2px solid white',
                                    backgroundColor: 'transparent',
                                    display: audioCurrentRef.current == 1 || audioCurrentRef.current == 3 ? 'block' : 'none'
                                }}
                            />
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '-5px',
                                    left: '120px',
                                    width: '120px',
                                    cursor: 'pointer',
                                    zIndex: 3,
                                    textAlign: 'center',
                                    fontSize: '12px',
                                    fontStyle: 'italic',
                                    backgroundColor: 'rgba(168, 50, 66 ,0.5)',
                                    padding: '8px',
                                    border: '2px outset black',
                                }}
                                onClick={()=> {audioCurrentRef.current = 1;
                                    setAudioCurrent(audioCurrentRef.current);
                                    pauseAudio();
                                    const t = getAudioTime();
                                    setAudioTime(t)}}
                            >
                                Kargiraa - 1 cavité
                            </div>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '-38px',
                                    left: '120px',
                                    width: '122px',
                                    cursor: 'pointer',
                                    zIndex: 3,
                                    textAlign: 'center',
                                    fontSize: '12px',
                                    fontStyle: 'normal',
                                    backgroundColor: 'rgba(168, 50, 66 ,0.9)',
                                    padding: '8px',
                                    border: '1px solid gray',
                                    display: showMenu1 ? 'block' : 'none',
                                    fontFamily: 'Times New Roman',
                                }}
                                onClick={() => {audioCurrentRef.current = 1;
                                    setAudioCurrent(audioCurrentRef.current);
                                    pauseAudio();
                                    const t = getAudioTime();
                                    setAudioTime(t); 
                                    setShowExplications3(true); stopAudio() }}
                            >
                                comprendre la technique
                            </div>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '-69px',
                                    left: '120px',
                                    width: '122px',
                                    cursor: 'pointer',
                                    zIndex: 3,
                                    textAlign: 'center',
                                    fontSize: '12px',
                                    fontStyle: 'normal',
                                    backgroundColor: 'rgba(168, 50, 66 ,0.9)',
                                    padding: '8px',
                                    border: '1px solid gray',
                                    display: showMenu1 ? 'block' : 'none',
                                    fontFamily: 'Times New Roman',
                                }}
                                onClick={() => {
                                    pauseAudio();
                                    const t = getAudioTime();
                                    if (audioCurrentRef.current !== 3) {
                                        audioCurrentRef.current = 3;
                                        setAudioCurrent(audioCurrentRef.current);
                                        setAudioTime(t);
                                        setAudioPlay(0);
                                        audio3.currentTime = t;
                                        audio3.play();
                                        setAudioPlay(1);
                                    } else {
                                        audioCurrentRef.current = 1;
                                        setAudioCurrent(audioCurrentRef.current);
                                        setAudioTime(t);
                                        setAudioPlay(0);
                                        audio1.currentTime = t;
                                        audio1.play();
                                        setAudioPlay(1);
                                    }
                                }}
                            >
                                {audioCurrentRef.current !== 3 ?
                                    'isoler les harmoniques'
                                    : 'rétablir le chant'
                                }
                            </div>
                        </div>
                        {/* drop-up menu n2 */}
                        <div
                            onMouseEnter={() => setShowMenu2(true)}
                            onMouseLeave={() => setShowMenu2(false)}
                            
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '-10px',
                                    left: '285px',
                                    width: '145px',
                                    height: '39px',
                                    border: '2px solid white',
                                    backgroundColor: 'transparent',
                                    display: audioCurrentRef.current == 2 || audioCurrentRef.current == 4 ? 'block' : 'none'
                                }}
                            />
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '-5px',
                                    left: '290px',
                                    width: '120px',
                                    cursor: 'pointer',
                                    zIndex: 3,
                                    textAlign: 'center',
                                    fontSize: '12px',
                                    fontStyle: 'italic',
                                    backgroundColor: 'rgba(168, 50, 66 ,0.5)',
                                    padding: '8px',
                                    border: '2px outset black',
                                }}
                                onClick={()=> {audioCurrentRef.current = 2;
                                    setAudioCurrent(audioCurrentRef.current);
                                    pauseAudio();
                                    const t = getAudioTime();
                                    setAudioTime(t)}}
                            >
                                Sygyt - 2 cavités
                            </div>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '-37px',
                                    left: '290px',
                                    width: '122px',
                                    cursor: 'pointer',
                                    zIndex: 3,
                                    textAlign: 'center',
                                    fontSize: '12px',
                                    fontStyle: 'normal',
                                    backgroundColor: 'rgba(168, 50, 66 ,0.9)',
                                    padding: '8px',
                                    border: '1px solid gray',
                                    display: showMenu2 ? 'block' : 'none',
                                    fontFamily: 'Times New Roman',
                                }}
                                onClick={() => { {audioCurrentRef.current = 2;
                                    setAudioCurrent(audioCurrentRef.current);
                                    pauseAudio();
                                    const t = getAudioTime();
                                    setAudioTime(t)};
                                    setShowTest(true); stopAudio() }}
                            >
                                tester la technique
                            </div>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '-69px',
                                    left: '290px',
                                    width: '122px',
                                    cursor: 'pointer',
                                    zIndex: 3,
                                    textAlign: 'center',
                                    fontSize: '12px',
                                    fontStyle: 'normal',
                                    backgroundColor: 'rgba(168, 50, 66 ,0.9)',
                                    padding: '8px',
                                    border: '1px solid gray',
                                    display: showMenu2 ? 'block' : 'none',
                                    fontFamily: 'Times New Roman',
                                }}
                                onClick={() => {{audioCurrentRef.current = 2;
                                    setAudioCurrent(audioCurrentRef.current);
                                    pauseAudio();
                                    const t = getAudioTime();
                                    setAudioTime(t)};
                                    setShowExplications2(true); stopAudio() }}
                            >
                                comprendre la technique
                            </div>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '-98px',
                                    left: '290px',
                                    width: '122px',
                                    cursor: 'pointer',
                                    zIndex: 3,
                                    textAlign: 'center',
                                    fontSize: '12px',
                                    fontStyle: 'normal',
                                    backgroundColor: 'rgba(168, 50, 66 ,0.9)',
                                    padding: '8px',
                                    border: '1px solid gray',
                                    display: showMenu2 ? 'block' : 'none',
                                    fontFamily: 'Times New Roman',
                                }}
                                onClick={() => {
                                    pauseAudio();
                                    const t = getAudioTime();
                                    if (audioCurrentRef.current !== 4) {
                                        audioCurrentRef.current = 4;
                                        setAudioCurrent(audioCurrentRef.current);
                                        setAudioTime(t);
                                        setAudioPlay(0);
                                        audio4.currentTime = t;
                                        audio4.play();
                                        setAudioPlay(1);
                                    } else {
                                        audioCurrentRef.current = 2;
                                        setAudioCurrent(audioCurrentRef.current);
                                        setAudioTime(t);
                                        setAudioPlay(0);
                                        audio2.currentTime = t;
                                        audio2.play();
                                        setAudioPlay(1);
                                    }
                                }}
                            >
                                {audioCurrentRef.current !== 4 ?
                                    'isoler les harmoniques'
                                    : 'rétablir le chant'
                                }
                            </div>
                        </div>
                    </div>

                </>
            }

        </div>
    );
}

export default Diphonique;
